export default __webpack_public_path__ + "static/media/gallery_10.d22c4d89.jpg";